const skillsListOptions = [
  "Frontend",
  "Backend",
  "Graphics/Animation",
  "Content Writing",
];

const genderOptions = ["Male", "Female", "Others"];
export { skillsListOptions, genderOptions };
